// auth.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../services';

const skipUrls = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const token = tokenService.getToken();
  const csrfToken = tokenService.getCsrfToken();

  const shouldSkip = skipUrls.some(url => req.url.includes(url));

  // ✅ NEW: If no token and not a public endpoint, redirect immediately
  // Don't even bother making the request — we know it'll 401
  if (!token && !shouldSkip) {
    const returnUrl = router.url.split('?')[0];
    if (!returnUrl.startsWith('/auth/login')) {
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl, reason: 'session_expired' }
      });
    }
    // Still let the request fail naturally so callers don't hang
    return next(req);
  }

  const stateChangingMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];
  const requiresCsrf = stateChangingMethods.includes(req.method);

  if (token && !shouldSkip) {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`
    };
    if (requiresCsrf && csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }
    return next(req.clone({ setHeaders: headers }));
  }

  return next(req);
};